import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-download-spinner"
export default class extends Controller {
  connect() {
    this.boundHandleFormSubmit = this.handleFormSubmit.bind(this)
    this.element.addEventListener('submit', this.boundHandleFormSubmit)
  }

  handleFormSubmit(e) {
    const submitButton = e.submitter

    if (submitButton && submitButton.name && submitButton.name.startsWith('download')) {
      document.dispatchEvent(new CustomEvent('spinner:show'))

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('spinner:hide'))

        const submitButtons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
        submitButtons.forEach(btn => {
          btn.disabled = false
        })
      }, 1500)
    }
  }

  disconnect() {
    this.element.removeEventListener('submit', this.boundHandleFormSubmit)
  }
}
